import React from 'react';
import axios from 'axios';

import { useModal } from '../Components/Modal/ModalContext';
import { useTimeModal } from '../Components/TimeModal/TimeModalContext';

import HeaderPanel from '../Components/HeaderPanel';
import AddNewLCPModal from '../Components/AddNewLabelCategoryPhaseModal';
import ChangeLabelCategotyPhaseModal from '../Components/ChangeLabelCategotyPhaseModal';

import Loading from '../Components/Loading';

import styles from '../styles/TableContainers.module.css';

const TypesCategoriesPhases = () => {
    const { openModal } = useModal();
    const { openTimeModal } = useTimeModal();
    const [cases, setCases] = React.useState([]);
    const [warning, setWarning] = React.useState('');
    const [loading, setLoading] = React.useState(true);
    const [visibilityButton, setVisibilityButton] = React.useState(false);
    const [reload, setReload] = React.useState(true);

    const [currentLCPId, setCurrentLCPId] = React.useState('');
    const [currentTypeForAdd, setCurrentTypeForAdd] = React.useState('');
    const [currentTypeForChange, setCurrentTypeForChange] = React.useState('');

    React.useEffect(() => {
        // setLoading(true); // Устанавливаем состояние загрузки перед запросом
        axios.get('/api/labels-categories-phases')
            .then(response => {
                if (response.data.length === 0) {
                    setWarning('Типы дел, категории и этапы отсутствуют в системе.');
                    setCases([]); // Очистить данные, если их нет
                    setVisibilityButton(true);
                } else {
                    const structuredData = response.data.map(label => {
                        return {
                            ...label,
                            categories: label.categories.map(category => {
                                return {
                                    ...category,
                                    phases: category.phases.sort((a, b) => a.order_of_phase - b.order_of_phase)
                                };
                            })
                        };
                    });
                    setWarning('');
                    setCases(structuredData);
                }
            })
            .catch(error => {
                console.error('Ошибка при получении данных: ', error);
                setWarning(`Не удалось загрузить таблицу:  ${error.response?.data.message || error.message}`);
            })
            .finally(() => {
                setReload(false);
                setLoading(false);
            });
    }, [reload]);

    const deleteLabel = (id) => {
        axios.delete(`/api/delete-label?id=${id}`)
        .then(() => {
            setReload(true);
            openTimeModal('Тип входящей корреспонденции удалён', 'success');
        })
        .catch((error) => {
            openTimeModal(`Не удалось удалить тип входящей корреспонденции.  ${error.response?.data.message || error.message}`, 'error');
        });
    }
    const deleteCategory = (id) => {
        axios.delete(`/api/delete-category?id=${id}`)
        .then(() => {
            setReload(true);
            openTimeModal('Категория входящей корреспонденции удалена', 'success');
        })
        .catch((error) => {
            openTimeModal(`Не удалось удалить категорию входящей корреспонденции.  ${error.response?.data.message || error.message}`, 'error');
        });
    }
    const deletePhase = (id) => {
        axios.delete(`/api/delete-phase?id=${id}`)
        .then(() => {
            setReload(true);
            openTimeModal('Этап удалён', 'success');
        })
        .catch((error) => {
            openTimeModal(`Не удалось удалить этап.  ${error.response?.data.message || error.message}`, 'error');
        });
    }

    const [isAddNewLCPModal, setIsAddNewLCPModal] = React.useState(false);
    const [isChangeLCPModal, setIsChangeLCPModal] = React.useState(false);

    return (
    <>
        {isAddNewLCPModal && <AddNewLCPModal closeModal={() => {setIsAddNewLCPModal(false)}} type={currentTypeForAdd} id={currentLCPId} onDoSuccess={() => {setReload(true)}} />}
        {isChangeLCPModal && <ChangeLabelCategotyPhaseModal closeModal={() => {setIsChangeLCPModal(false)}} type={currentTypeForChange} id={currentLCPId} onDoSuccess={() => {setReload(true)}} />}
        <div className='mainContainer'>
            <h1>Категории и этапы</h1>
            <div className='infoBlock'>
                <a>При редактировании названий или сроков существующих этапов изменения вступают в силу сразу и применяются ко всем открытым делам.<br/>При удалении этапа из системы все уже открытые дела сохранят прежнюю версию.<br/><br/>Рекомендуется вносить изменения в дерево категорий и этапов в вечернее время.</a>
            </div>
            <HeaderPanel typePanel='Назад' />
            {loading ? 
            (
                <Loading />
            ) : (
            warning ? 
            (
                <>
                {visibilityButton && (
                    <button type="button" className="button" style={{ margin: '10px 0 0 0', width: 'fit-content' }} onClick={() => {setIsAddNewLCPModal(true); setCurrentTypeForAdd('label')}}>
                        <svg viewBox="0 0 24 24" id="plus" fill="currentColor">
                            <path d="M19,11H13V5a1,1,0,0,0-2,0v6H5a1,1,0,0,0,0,2h6v6a1,1,0,0,0,2,0V13h6a1,1,0,0,0,0-2Z"></path>
                        </svg>
                        Добавить новый тип
                    </button>)
                }
                <div className='case warningLine' style={{ margin: '12px 0'}}><a>{warning}</a></div>
                </>
            )
            :
            (
            <>
                {/* <button type="button" className="button" style={{ margin: '10px 0 0 0', width: 'fit-content' }} onClick={() => {setIsAddNewLCPModal(true); setCurrentTypeForAdd('label')}}>
                    <svg viewBox="0 0 24 24" id="plus" fill="currentColor">
                        <path d="M19,11H13V5a1,1,0,0,0-2,0v6H5a1,1,0,0,0,0,2h6v6a1,1,0,0,0,2,0V13h6a1,1,0,0,0,0-2Z"></path>
                    </svg>
                    Добавить новый тип
                </button> */}
                {cases.map(label => (
                <div key={label.id}>
                    <div className={styles.tableDescription}>
                        <h2>{label.name}</h2>
                        {/* <span>
                            <svg viewBox="0 0 24 24" id="pen" onClick={() => {setIsChangeLCPModal(true); setCurrentTypeForChange('label'); setCurrentLCPId(label.id)}}><path fill="#6563FF" d="M22,7.24a1,1,0,0,0-.29-.71L17.47,2.29A1,1,0,0,0,16.76,2a1,1,0,0,0-.71.29L13.22,5.12h0L2.29,16.05a1,1,0,0,0-.29.71V21a1,1,0,0,0,1,1H7.24A1,1,0,0,0,8,21.71L18.87,10.78h0L21.71,8a1.19,1.19,0,0,0,.22-.33,1,1,0,0,0,0-.24.7.7,0,0,0,0-.14ZM6.83,20H4V17.17l9.93-9.93,2.83,2.83ZM18.17,8.66,15.34,5.83l1.42-1.41,2.82,2.82Z"></path></svg>
                            <svg viewBox="0 0 24 24" id="trash-alt" onClick={() => {deleteLabel(label.id)}}><path fill="#ff1818" d="M10,18a1,1,0,0,0,1-1V11a1,1,0,0,0-2,0v6A1,1,0,0,0,10,18ZM20,6H16V5a3,3,0,0,0-3-3H11A3,3,0,0,0,8,5V6H4A1,1,0,0,0,4,8H5V19a3,3,0,0,0,3,3h8a3,3,0,0,0,3-3V8h1a1,1,0,0,0,0-2ZM10,5a1,1,0,0,1,1-1h2a1,1,0,0,1,1,1V6H10Zm7,14a1,1,0,0,1-1,1H8a1,1,0,0,1-1-1V8H17Zm-3-1a1,1,0,0,0,1-1V11a1,1,0,0,0-2,0v6A1,1,0,0,0,14,18Z"></path></svg>
                        </span> */}
                    </div>
                    {/* <a className={`${styles.mobileAddNewCategoryBtn} button`} onClick={() => {setIsAddNewLCPModal(true); setCurrentTypeForAdd('category'); setCurrentLCPId(label.id)}}><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="plus"><path fill="currentColor" d="M19,11H13V5a1,1,0,0,0-2,0v6H5a1,1,0,0,0,0,2h6v6a1,1,0,0,0,2,0V13h6a1,1,0,0,0,0-2Z"></path></svg>Добавить новую категорию</a> */}
                    {label.categories.length > 0 ? (
                        <>
                        {label.categories.map(category => (
                        
                            <div className={styles.tableContainer}>
                                <div key={category.id} className={styles.tableHeader}>
                                    <h2>{category.name}</h2>
                                    <span>
                                        <svg viewBox="0 0 24 24" id="pen" onClick={() => {setIsChangeLCPModal(true); setCurrentTypeForChange('category'); setCurrentLCPId(category.id)}}><path fill="#6563FF" d="M22,7.24a1,1,0,0,0-.29-.71L17.47,2.29A1,1,0,0,0,16.76,2a1,1,0,0,0-.71.29L13.22,5.12h0L2.29,16.05a1,1,0,0,0-.29.71V21a1,1,0,0,0,1,1H7.24A1,1,0,0,0,8,21.71L18.87,10.78h0L21.71,8a1.19,1.19,0,0,0,.22-.33,1,1,0,0,0,0-.24.7.7,0,0,0,0-.14ZM6.83,20H4V17.17l9.93-9.93,2.83,2.83ZM18.17,8.66,15.34,5.83l1.42-1.41,2.82,2.82Z"></path></svg>
                                        <svg viewBox="0 0 24 24" id="trash-alt" onClick={() => {deleteCategory(category.id)}}><path fill="#ff1818" d="M10,18a1,1,0,0,0,1-1V11a1,1,0,0,0-2,0v6A1,1,0,0,0,10,18ZM20,6H16V5a3,3,0,0,0-3-3H11A3,3,0,0,0,8,5V6H4A1,1,0,0,0,4,8H5V19a3,3,0,0,0,3,3h8a3,3,0,0,0,3-3V8h1a1,1,0,0,0,0-2ZM10,5a1,1,0,0,1,1-1h2a1,1,0,0,1,1,1V6H10Zm7,14a1,1,0,0,1-1,1H8a1,1,0,0,1-1-1V8H17Zm-3-1a1,1,0,0,0,1-1V11a1,1,0,0,0-2,0v6A1,1,0,0,0,14,18Z"></path></svg>
                                    </span>
                                </div>
                                
                                    
                                <div className={styles.tableBody}>
                                    {category.phases.length > 0 ? (
                                        category.phases.map(phase => (
                                            phase.message ? (
                                            <div className={styles.tableLine}>
                                                <a key={`message-${category.id}`} className={styles.noPhases}>
                                                    {phase.message}
                                                </a>
                                            </div>
                                            ) : (
                                            <div className={styles.tableLine}>
                                                <div className={styles.PhaseNameAndParam}>
                                                    <a key={phase.id} className={styles.phaseOrder} title='Порядок'>
                                                        {phase.order_of_phase}
                                                    </a>
                                                    <a key={phase.id} className={styles.phaseName}>
                                                        {phase.name}
                                                    </a>
                                                    <a className={styles.phaseParam}>
                                                        Время исполнения в днях: {phase.time}; Только рабочие дни: {phase.typesch ? 'Да' : 'Нет'}
                                                    </a>
                                                </div>
                                                <span>
                                                    <svg viewBox="0 0 24 24" id="pen" onClick={() => {setIsChangeLCPModal(true); setCurrentTypeForChange('phase'); setCurrentLCPId(phase.id)}}><path fill="#6563FF" d="M22,7.24a1,1,0,0,0-.29-.71L17.47,2.29A1,1,0,0,0,16.76,2a1,1,0,0,0-.71.29L13.22,5.12h0L2.29,16.05a1,1,0,0,0-.29.71V21a1,1,0,0,0,1,1H7.24A1,1,0,0,0,8,21.71L18.87,10.78h0L21.71,8a1.19,1.19,0,0,0,.22-.33,1,1,0,0,0,0-.24.7.7,0,0,0,0-.14ZM6.83,20H4V17.17l9.93-9.93,2.83,2.83ZM18.17,8.66,15.34,5.83l1.42-1.41,2.82,2.82Z"></path></svg>
                                                    <svg viewBox="0 0 24 24" id="trash-alt" onClick={() => {deletePhase(phase.id)}}><path fill="#ff1818" d="M10,18a1,1,0,0,0,1-1V11a1,1,0,0,0-2,0v6A1,1,0,0,0,10,18ZM20,6H16V5a3,3,0,0,0-3-3H11A3,3,0,0,0,8,5V6H4A1,1,0,0,0,4,8H5V19a3,3,0,0,0,3,3h8a3,3,0,0,0,3-3V8h1a1,1,0,0,0,0-2ZM10,5a1,1,0,0,1,1-1h2a1,1,0,0,1,1,1V6H10Zm7,14a1,1,0,0,1-1,1H8a1,1,0,0,1-1-1V8H17Zm-3-1a1,1,0,0,0,1-1V11a1,1,0,0,0-2,0v6A1,1,0,0,0,14,18Z"></path></svg>
                                                </span>
                                            </div>
                                            )
                                        ))
                                    ) : (
                                        <a>В данной категории нет ни одного этапа.</a>
                                    )}
                                    <div className={styles.tableLine} style={{borderBottom: 'none'}}>
                                        <button type='button' className={styles.button} style={{width: 'fit-content'}} onClick={() => {setIsAddNewLCPModal(true); setCurrentTypeForAdd('phase'); setCurrentLCPId(category.id)}}>
                                            <svg viewBox="0 0 24 24" id="plus" fill="white"><path d="M19,11H13V5a1,1,0,0,0-2,0v6H5a1,1,0,0,0,0,2h6v6a1,1,0,0,0,2,0V13h6a1,1,0,0,0,0-2Z"></path></svg>
                                            Добавить этап
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))}
                        </>
                    ) : (
                        <div className={styles.tableContainer}>
                            <div className={styles.tableBody}>
                                <div className={styles.tableLine} style={{borderBottom: 'none'}}>
                                    <a>В данном типе дел нет ни одной категории.</a>
                                </div>
                            </div>
                        </div>
                    )}
                    <div className={styles.tableContainer}>
                        <div className={styles.tableBody}>
                            <div className={styles.tableLine} style={{borderBottom: 'none'}}>
                                <a className={styles.newCategoryBtn} onClick={() => {setIsAddNewLCPModal(true); setCurrentTypeForAdd('category'); setCurrentLCPId(label.id)}}>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="plus"><path fill="currentColor" d="M19,11H13V5a1,1,0,0,0-2,0v6H5a1,1,0,0,0,0,2h6v6a1,1,0,0,0,2,0V13h6a1,1,0,0,0,0-2Z"></path></svg>
                                    Добавить новую категорию
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                ))}
            </>
            ))}
        </div>
    </>
    );
};

export default TypesCategoriesPhases;
